/*eslint-disable*/
import Axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';


const MyModel = ({
    field: { name, },
    form: { setFieldValue },
    ...props
}) => {


    const [models, setmodels] = useState([])
    useEffect(() => {
        if (props.dataId) {
            let token = localStorage.getItem('apiToken')
            let userId = localStorage.getItem('userId')
            let customerNo = localStorage.getItem('customerNo')


            Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleModel/${props.dataId}?customerNumber=${customerNo}&userId=${userId}`,{
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                setmodels(response.data.resultSet);
            }))
            .catch(error => {
                console.log(error);
            })
        }
         console.log('---00', props.dataId)
    }, [props.dataId])

    let tyermodels = []
    if (models.length > 0) {
        models.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleModelCode
            temp.text = object.vehicleModel
            temp.value = object.vehicleModelId
            return tyermodels[index] = temp
        })
    }

    const initialvalue = props.value
    console.log("Models", models)

    return (
        <Dropdown
            selection
            clearable
            style={{ width: '100%' }}
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={tyermodels}
            defaultValue={initialvalue}
            {...props}
            dataid={props.dataid}
        />

    )
}

export default MyModel